// ##############################
// // // socmembers
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const socmembers = [
    {avatar: IMGDIR+"/images/social/socmembers/member-4.jpg", name: "Grace Turner", position: "Editor", age: "26"},
    {avatar: IMGDIR+"/images/social/socmembers/member-5.jpg", name: "Irene Smith", position: "Painter", age: "31"},
    {avatar: IMGDIR+"/images/social/socmembers/member-12.jpg", name: "Colin Taylor", position: "Developer", age: "35"},
    {avatar: IMGDIR+"/images/social/socmembers/member-14.jpg", name: "Fiona Vance", position: "Journalist", age: "42"},
    {avatar: IMGDIR+"/images/social/socmembers/member-1.jpg", name: "Lily White", position: "Designer", age: "33"},
    {avatar: IMGDIR+"/images/social/socmembers/member-15.jpg", name: "Leah Young", position: "Photographer", age: "25"},
    {avatar: IMGDIR+"/images/social/socmembers/member-16.jpg", name: "Julia Vasar", position: "Housewife", age: "32"},
    {avatar: IMGDIR+"/images/social/socmembers/member-3.jpg", name: "Evan Short", position: "Web Developer", age: "37"},

]; 

export {
    socmembers, 
};
